import { publishFragment } from "core/services/site/fragment";
import { getTask } from "core/services/site/task";
import createPoller from "utils/createPoller";
import getTaskId from "utils/getTaskId";

const fragmentPublish = async (
    selectedOutput: string,
    selectedModule: string,
    sessionToken: string,
    fragmentId: number,
): Promise<void> => {
    await publishFragment(
        sessionToken,
        fragmentId,
        selectedModule,
        selectedOutput,
    );
    const taskId = await getTaskId(sessionToken, fragmentId);
    if (taskId) {
        let failureCount = 0;
        await createPoller(async () => {
            try {
                const taskInfo = await getTask(sessionToken, taskId);
                if (taskInfo.value?.processing) {
                    return false;
                }
                return true;
            } catch (error) {
                failureCount += 1;
                if (failureCount > 4) {
                    // Assume this fragment is broken and stop polling
                    return true;
                }
                return false;
            }
        }, [{ iterations: 500, interval: 2000 }]);
    } else {
        throw new Error("fragment could not be found");
    }
};

export default fragmentPublish;
